<template>
  <v-tooltip location="bottom">
    <template #activator="{ props }">
      <v-icon
        v-bind="props"
        size="small"
        color="primary"
        class="mr-2"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <span v-html="formattedText"></span>
  </v-tooltip>
</template>

<script>
export default {
  name: "InfoIcon",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedText() {
      const words = this.text.split(' ');
      const wordsPerLine = 10;
      const lines = [];

      for (let i = 0; i < words.length; i += wordsPerLine) {
        const line = words.slice(i, i + wordsPerLine).join(' ');
        lines.push(line);
      }

      return lines.join('<br>');
    },
  },
};
</script>
